// extracted by mini-css-extract-plugin
export default {"container":"fj3QW1","arrow":"ydLpez","isOpen":"wzIrXX","ltr":"zLYJMs","value":"jcCsdn","rtl":"fcfXG6"};